import * as React from "react"
import styled, { css } from "styled-components"

import { Color, LineHeight, TextSize } from "~/consts/style-mixins"

interface Props {
  type: keyof typeof Type
  className?: string
  // NOTE: color, lineHeight だと chakra の props と競合してしまう
  colorProp?: string
  lineHeightProp?: number
  onClick?: () => void
  inline?: boolean
}

type StyledProps = { styleByType: string } & Pick<Props, "colorProp" | "lineHeightProp" | "inline">

const Typography: React.FC<Props> = ({ type, ...props }) => {
  return <StyledTypography {...props} styleByType={styleByType[type]} />
}

export default Typography

export const Type = {
  // 新定義：必ずこの中から使ってください
  Hero: "Hero",
  SubHero: "SubHero",
  Heading: "Heading",
  SubHeading: "SubHeading",
  Label: "Label",
  SubLabel: "SubLabel",
  Description: "Description",
  Note: "Note",
  SubNote: "SubNote",
  // 旧定義：使わないでください
  Body: "Body",
  LargeLabel: "LargeLabel",
  MediumLabel: "MediumLabel",
  SmallLabel: "SmallLabel",
  Caption: "Caption",
}

const styleByType = {
  // 新定義：必ずこの中から使ってください
  Hero: `
    font-size: ${TextSize["2XL"]}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.Black}
  `,
  SubHero: `
    font-size: ${TextSize.XL}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.Black}
  `,
  Heading: `
    font-size: ${TextSize.L}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.Black}
  `,
  SubHeading: `
    font-size: ${TextSize.M}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.Black}
  `,
  Label: `
    font-size: ${TextSize.S}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.LightGray}
  `,
  SubLabel: `
    font-size: ${TextSize.XS}px
    font-weight: bold
    line-height: ${LineHeight.S}%
    color: ${Color.LightGray}
  `,
  Description: `
    font-size: ${TextSize.S}px
    font-weight: normal
    line-height: ${LineHeight.L}%
    color: ${Color.Black}
  `,
  Note: `
    font-size: ${TextSize.S}px
    font-weight: normal
    line-height: ${LineHeight.M}%
    color: ${Color.Gray}
  `,
  SubNote: `
    font-size: ${TextSize["XS"]}px
    font-weight: normal
    line-height: ${LineHeight.M}%
    color: ${Color.Gray}
  `,
  Caption: `
    font-size: ${TextSize._2XS}px
    font-weight: normal
    line-height: ${LineHeight.S}%
  `,
  // 旧定義：使わないでください
  Body: `
    font-size: ${TextSize.M}/px
    font-weight: normal
    line-height: ${LineHeight.L}%
  `,
  LargeLabel: `
    font-size: ${TextSize.S}px
    font-weight: bold
    line-height: ${LineHeight.XS}%
  `,
  MediumLabel: `
    font-size: ${TextSize.XS}px
    font-weight: bold
    line-height: ${LineHeight.XS}%
  `,
  SmallLabel: `
    font-size: ${TextSize._2XS}px
    font-weight: bold
    line-height: ${LineHeight.XS}%
  `,
}

const StyledTypography = styled.div<StyledProps>`
  ${({ styleByType }) => css`
    ${styleByType}
  `};
  ${({ colorProp }) => colorProp && `color: ${colorProp}`};
  ${({ lineHeightProp }) => lineHeightProp && `line-height: ${lineHeightProp}%`};
  ${({ inline }) => inline && "display: inline"};
`
